var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          staticClass: "verification-method-select",
          attrs: { placeholder: "Choose..." },
          on: { change: _vm.notifyParent },
          model: {
            value: _vm.selectedVerificationMethod,
            callback: function ($$v) {
              _vm.selectedVerificationMethod = $$v
            },
            expression: "selectedVerificationMethod",
          },
        },
        _vm._l(_vm.allowedVerificationMethods, function (allowedMethod) {
          return _c(
            "el-option",
            {
              key: allowedMethod.value,
              attrs: { label: allowedMethod.label, value: allowedMethod.value },
            },
            [
              _c("span", { staticClass: "option-container" }, [
                _c("div", { staticClass: "option-icon-container" }, [
                  _c("img", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: { src: _vm.getIcon(allowedMethod) },
                  }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "select-label" }, [
                  _vm._v(_vm._s(allowedMethod.label) + " "),
                ]),
              ]),
              _vm._v(" "),
              allowedMethod.value === _vm.selectedVerificationMethod
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        float: "right",
                        color: "#8492a6",
                        "font-size": "13px",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: { src: _vm.icons.check },
                      }),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }